#import "../fragments/audience-membership-stats-fragment.graphql"

query GetAudienceMembershipStats($audienceId: ID!) {
    audience(id: $audienceId) {
        ...AudienceMembershipStats
    }
}
